import cssConstants from '@renderer-ui-library/base/constants.module.scss'
import { useMediaQuery } from '@renderer-ui-library/mui/utils/mediaQuery/useMediaQuery'

const headerHeight = {
  xs: parseInt(cssConstants.headerHeightXs),
  sm: parseInt(cssConstants.headerHeightSm),
  md: parseInt(cssConstants.headerHeightMd),
}

export const useHeaderHeight = () => {
  const { isMobile, isMobileSmall } = useMediaQuery()
  if (isMobileSmall) {
    return headerHeight.xs
  }
  if (isMobile) {
    return headerHeight.sm
  }
  return headerHeight.md
}
